import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import {computed} from 'vue';
import {FILTER_OPERATION_ARRAY_CONTAINS_ALL} from "~/cabinet/vue/interface/filter/Operations";
import TagInterface from "~/cabinet/vue/interface/form/tags/TagInterface";
import FilterableContentWrapperInterface from "~/cabinet/vue/interface/data/FilterableContentWrapperInterface";


const __default__ = {
    name: "Tags"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    tags: { default: () => ([]) },
    type: { default: "info" },
    effect: {},
    filterableContentWrapper: {},
    filterId: {},
    maximum: {},
    withBorder: { type: Boolean },
    possibleTags: {},
    clickable: { type: Boolean },
    closable: { type: Boolean }
  },
  emits: ["click", "close"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit

let isFilterable = computed(() => {
    return !!(props.filterableContentWrapper && props.filterId);
});

function onClick(event: MouseEvent, tag: string) {
    if (isFilterable.value) {
        event.stopPropagation();
        props.filterableContentWrapper.addFilterValue({
            id: props.filterId,
            operation: FILTER_OPERATION_ARRAY_CONTAINS_ALL,
            value: tag
        });
    }
    emits("click", tag);
}

let computedTags = computed<TagInterface[]>(() => {
    return props.tags.map(tag => {
        if (typeof tag == "string") {
            if (props.possibleTags) {
                let item = props.possibleTags.find(item => item.tag == tag);
                if (item) {
                    tag = item;
                }
            }
            if (typeof tag == "string") {
                tag = {
                    tag,
                    color: null,
                    cc: null,
                    availableFor: [],
                    description: null
                };
            }
        }
        return tag;
    });
});

function getTagStyle(tag: TagInterface) {
    if (tag.color) {
        if (props.effect == "plain") {
            return {
                background: "transparent",
                color: tag.color,
                borderColor: tag.color
            }
        } else {
            return {
                background: tag.color,
                color: tag.textColor ?? "#fff"
            }
        }
    }
    return null;
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            'tags': true,
            'with-border': __props.withBorder
        })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(computedTags), (tag, key) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
        (!__props.maximum || key <= __props.maximum)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (__props.maximum && key == __props.maximum)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: __props.type,
                    effect: __props.effect,
                    size: "small",
                    class: _normalizeClass({
                            'mr-1': true,
                            tag: true
                        })
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" +" + _toDisplayString(_unref(computedTags).length - __props.maximum), 1)
                    ]),
                    _: 1
                  }, 8, ["type", "effect"]))
                : (!__props.maximum || key < __props.maximum)
                  ? _withDirectives((_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: __props.type,
                      effect: __props.effect,
                      style: _normalizeStyle(getTagStyle(tag)),
                      size: "small",
                      closable: __props.closable,
                      class: _normalizeClass({
                            'mr-1': true,
                            clickable: _unref(isFilterable) || __props.clickable,
                            'tag': true
                        }),
                      onClose: ($event: any) => (_unref(emits)('close', tag.tag))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tag.tag), 1)
                      ]),
                      _: 2
                    }, 1032, ["type", "effect", "style", "closable", "class", "onClose"])), [
                      [_directive_my_tooltip, _unref(isFilterable) ? 'Кликните, чтобы отфильтровать по этому тэгу' : undefined],
                      [_directive_on_native, (e) => onClick(e, tag.tag), "click"]
                    ])
                  : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ], 2))
}
}

})